import reactImg from "../images/tech_images/reactImg.png"
// import reduxImg from "../images/tech_images/reduxImg.png"
import jsImg from "../images/tech_images/jsImg.png"
import cssImg from "../images/tech_images/cssImg.png"
import html5Img from "../images/tech_images/html5Img.png"
import rubyImg from "../images/tech_images/rubyImg.png"
import railsImg from "../images/tech_images/railsImg.png"
import gitImg from "../images/tech_images/gitImg.png"
import postgresqlImg from "../images/tech_images/postgresqlImg.png"
import abletonImg from "../images/tech_images/abletonImg.png"
import seratoImg from "../images/tech_images/seratoImg.png"
import pythonImg from "../images/tech_images/python.png"


export const imageData = [
  {
    tech_name: "React",
    tech_img: reactImg,
  },
  {
    tech_name: "Python",
    tech_img: pythonImg,
  },
  {
    tech_name: "JavaScript",
    tech_img: jsImg,
  },
  {
    tech_name: "CSS",
    tech_img: cssImg,
  },
  {
    tech_name: "HTML5",
    tech_img: html5Img,
  },
  {
    tech_name: "Ruby",
    tech_img: rubyImg,
  },
  {
    tech_name: "Rails",
    tech_img: railsImg,
  },
  {
    tech_name: "Git",
    tech_img: gitImg,
  },
  {
    tech_name: "PostgreSQL",
    tech_img: postgresqlImg,
  },
  {
    tech_name: "Ableton Live",
    tech_img: abletonImg,
  },
  {
    tech_name: "Serato",
    tech_img: seratoImg,
  },
]
